import React from 'react';
import { FDAlert } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const RichTextAlertDescription = ({ value }) => {
  return (
    <FDAlert
      status="info"
      description={value}
    />
  );
};

RichTextAlertDescription.defaultProps = {
  value: undefined,
};

RichTextAlertDescription.propTypes = {
  value: PropTypes.string,
};
